import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import style from './style.module.less';

export const ImportStatusSuccess = () => {
  return (
    <div className={style['import-status-success']}>
      <FontAwesomeIcon className={style['completed-icon']} icon={faCheckCircle} />
      <FormattedMessage {...messages.importSuccessful} />
    </div>
  );
};
